<script lang="ts">
    import Component from 'vue-class-component';
    import Vue from "vue";
    import { ellipsis, isNullOrWhitespace, strCompareLowerCase } from "@common/Common";

    @Component({
        props: {
            CorrelationId: String,
            Attributes: Array,
            SelectedAttributesIds: Array
        }
    })
    export default class AttributesSelector extends Vue
    {
        sections: SectionViewModel[] = [];
        attributes: AttributeViewModel[] = [];
        searchPhrase: string = null;

        get sectionsView(): SectionViewModel[]
        {
            let view = new Array(...this.sections);

            if (!isNullOrWhitespace(this.searchPhrase))
            {
                return view.filter(a => a.attributesView.length > 0);
            }

            return view;
        }

        get selectedAttributes(): AttributeViewModel[] { return this.attributes.filter(a => a.IsSelected); }


        mounted()
        {
            this.attributes = this.$props.Attributes.map(a => new AttributeViewModel(a));

            const selectedAttributesIds: number[] = this.$props.SelectedAttributesIds;
            this.attributes.filter(a => selectedAttributesIds.indexOf(a.AttributeId) > -1).forEach(a => a.IsSelected = true);

            this.sections = this.attributes
                .map(a => a.Section)
                .filter((v, i, sectionsNames) => sectionsNames.indexOf(v) === i)//choose unique
                .sort((a, b) => strCompareLowerCase(a, b))
                .map(a =>
                {
                    const attributes = this.attributes.filter(b => a === b.Section);
                    return new SectionViewModel(a, attributes, this);
                });
        }

        save()
        {
            this.$emit('save',
            {
                CorrelationId: this.$props.CorrelationId,
                SelectedAttributesIds: this.selectedAttributes.map(a => a.AttributeId)
            });
        }

        close()
        {
            this.$emit('close');
        }
    }

    class SectionViewModel
    {
        Parent: AttributesSelector;

        Name: string;
        Attributes: AttributeViewModel[];

        get attributesView(): AttributeViewModel[]
        {
            let view = new Array(...this.Attributes);

            if (!isNullOrWhitespace(this.Parent.searchPhrase))
            {
                const phrase = this.Parent.searchPhrase.toLowerCase();
                view = this.Attributes.filter(o => `${o.Name} ${o.Section}`.toLowerCase().indexOf(phrase) >= 0);
            }

            return view;
        }

        constructor(name: string, attributes: AttributeViewModel[], parent: AttributesSelector)
        {
            this.Parent = parent;
            this.Name = name;
            this.Attributes = attributes;
        }
    }

    class AttributeViewModel
    {
        AttributeId: number;
        Name: string;
        Section: string;
        NameEllipsis: string;

        IsSelected: boolean = false;

        constructor(attr: { AttributeId: number, Name: string, Section: string })
        {
            this.AttributeId = attr.AttributeId;
            this.Name = attr.Name;
            this.Section = attr.Section;
            this.NameEllipsis = ellipsis(this.Name, 52);
        }

        toggleSelect()
        {
            this.IsSelected = !this.IsSelected;
        }
    }

</script>

<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content" style="height: calc(100vh - 50px);">
                    <div class="modal-header">
                        <h5 class="modal-title">Select attributes</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">

                        <div class="row">

                            <div class="col-md-6">
                                <div class="input-group">
                                    <input type="search" placeholder="Search..." class="form-control" v-model.trim="searchPhrase">
                                    <span class="input-group-append">
                                        <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                                    </span>
                                </div>
                                <div style="max-height: calc(100vh - 280px); overflow-y: auto;" class="mt-3">
                                    <div v-for="s in sectionsView" :key="s.Name">
                                        <h6 class="mt-3 mb-1">{{s.Name}}</h6>
                                        <div v-for="attr in s.attributesView" :key="attr.AttributeId">
                                            <a class="dropdown-item" @click="attr.toggleSelect()">
                                                <i class="fa-regular fa-lg" :class="{ 'fa-square-check': attr.IsSelected, 'fa-square': !attr.IsSelected}"></i>
                                                <span v-bind:title="attr.Name">{{attr.NameEllipsis}}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-md-6">
                                <h5>Selected attributes ({{selectedAttributes.length}}):</h5>
                                <div style="max-height: calc(100vh - 280px); overflow-y: auto;">
                                    <div v-for="attr in selectedAttributes" :key="attr.AttributeId" class="p-2 bg-secondary m-2 text-white">
                                        <span v-bind:title="attr.Name">{{attr.NameEllipsis}}</span>
                                        <button type="button" class="p-0 border-0 text-white" style="background-color: transparent; font-size: 1.3rem; float: right;"
                                                @click="attr.toggleSelect()">
                                            &times;
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="modal-footer">
                        <button @click="save" type="button" class="btn btn-primary">Save &amp; Close</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>